import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorStrategyAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#TwoColorStrategy_Alert_svg__a)">
      <path
        fill="#F7A600"
        d="M15.043 8.864a.421.421 0 0 0-.464-.554l-3.45.55a.421.421 0 0 0-.156.773l1.488.926.654 1.627a.421.421 0 0 0 .789-.02l1.14-3.302Z"
      />
      <path
        fill={getTheme(props["data-theme"])}
        d="M18.393 3.924a1.531 1.531 0 0 1 1.694 2.02l-5.239 14.86c-.47 1.335-2.345 1.371-2.867.055l-2.928-7.378-6.757-4.164c-1.206-.743-.844-2.583.552-2.814l15.545-2.58Zm.257 1.479h-.012L3.094 7.983c-.012.001-.016.004-.017.004 0 0-.006.007-.009.02a.043.043 0 0 0 0 .022s.004.005.015.011l7.18 4.425 3.112 7.841a.058.058 0 0 0 .008.015c0 .001.009.005.022.005s.02-.004.02-.005c.001 0 0 0 0 0 .001 0 .005-.005.009-.016l5.239-14.86a.044.044 0 0 0 .003-.012V5.43a.037.037 0 0 0-.009-.015.036.036 0 0 0-.013-.01l-.004-.001Z"
      />
    </g>
    <defs>
      <clipPath id="TwoColorStrategy_Alert_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTwoColorStrategyAlert;
